module.exports = __webpack_public_path__ + "static/media/bnb.13190e01.webp";